import SectionHeading from "./SectionHeading";
import { overviewFacts, overviewIntro } from "@/mocks/movieData";

export default function OverviewSection() {
  return (
    <section id="overview" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Basic Info"
          title="影片概览：这是一部什么样的故事"
          desc="先用一组基础信息快速建立认知，再逐段了解剧情定位与版本差异。"
        />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {overviewFacts.map((fact) => (
            <div
              key={fact.key}
              className="rounded-lg bg-background-100 border border-background-200 p-3 md:p-4 flex flex-col gap-2 hover:border-primary-200 transition-colors"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 text-lg">
                <i className={fact.icon} />
              </span>
              <div className="text-xs text-foreground-500">{fact.key}</div>
              <div className="text-sm font-medium text-foreground-950 leading-snug">{fact.value}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-8 bg-background-100 border border-background-200 rounded-xl p-5 md:p-7">
            <h3 className="text-lg md:text-xl font-semibold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-quill-pen-line text-primary-500" /> 主题与浏览说明
            </h3>
            <div className="space-y-4">
              {overviewIntro.map((para, idx) => (
                <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4 flex flex-col gap-4">
            <div className="rounded-xl bg-secondary-100 border border-secondary-200 p-5">
              <h4 className="text-base font-semibold text-secondary-900 flex items-center gap-2">
                <i className="ri-information-line" /> 版本提示
              </h4>
              <p className="mt-2 text-sm text-secondary-900/80 leading-relaxed">
                观看前请先确认版本是否为「无删减完整版」。完整版保留更完整的铺垫段落与关键对白，人物动机更连贯。
              </p>
            </div>
            <div className="rounded-xl bg-accent-100 border border-accent-200 p-5">
              <h4 className="text-base font-semibold text-accent-900 flex items-center gap-2">
                <i className="ri-lightbulb-line" /> 快速定位
              </h4>
              <ul className="mt-3 space-y-2 text-sm text-accent-900/85">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line mt-0.5" /> 想先看剧情，跳到「剧情与看点」
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line mt-0.5" /> 关心清晰度，跳到「画质版本」
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line mt-0.5" /> 遇到卡顿，跳到「播放线路」
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}